import cartsCrcCodes from '@nike/ux-tread-crc-code/lib/buy/carts/v2/crcCodes';
import foffJobsCrcCodes from '@nike/ux-tread-crc-code/lib/buy/fulfillment_offerings_jobs/v1/crcCodes';
import cartReviewsCrcCodes from '@nike/ux-tread-crc-code/lib/buy/cart_reviews/v2/crcCodes';

export const CART_RELATED_ERRORS_TO_EXCLUDE = [
  cartsCrcCodes['404'], // empty cart error
  foffJobsCrcCodes.REQUEST_INVALID, // Invalid zip code (dont display modal, highlight input instead)
  foffJobsCrcCodes.FULFILLMENT_OFFERINGS_NOT_FOUND,
  cartReviewsCrcCodes.FIELD_INVALID,
];
export const CART_RELATED_WARNINGS_TO_INCLUDE = [
  cartsCrcCodes.COUNTRY_NOT_SUPPORTED,
  cartsCrcCodes.PROMOTION_NOT_APPLIED,
  cartReviewsCrcCodes.FIELD_INVALID,
];
